export const DINEOUT_CART_WEBVIEW_OBJECT_KEY = "dineoutCartInfo";

export const PAYMENT_HEADER_THEME = {
    LIGHT: "light",
    DARK: "dark",
};

export const PROCEED_TOPAY_TEXT = "Proceed to Pay";
export const PAYING = "Paying";

export const CONVENIENCE_FEE_TYPE = "convenienceFee";

export const COUPON_TOAST_IMAGE = "unified-discounting/CouponCartToastError";
export const COUPON_TOAST_SUCCESS_IMAGE = "unified-discounting/CouponCartToast";
export const QR_INVALID_IMAGE_ID = "dineout/generic/candle.png";
export const FAILED_TEXT = "failed!";
export const INVALID_COUPON = "Coupon is invalid";

export const COUPON_TOAST_SUCCESS_CTA = {
    text: "YAY!",
    color: "text_Button_Secondary",
};

export const COUPON_TOAST_CTA = {
    text: "TRY AGAIN",
    color: "text_Button_Secondary",
};

export enum SWIGGY_USER_TYPE {
    ONE_USER = "SUPER",
    WAS_ONE_USER = "WAS_SUPER",
    NON_ONE_USER = "NON_SUPER",
}

export enum DealCategory {
    BAU = "Pre-Book",
    PREEBOOK_POS = "Prebook_Pos",
    GIRF = "GIRF",
    RESERVATION = "RESERVATION",
    RESERVATION_POS = "RESERVATION_POS",
    EVENTS = "EVENTS",
    DEFAULT = "Default",
    EVENTS_POST_PAYMENT = "EVENTS_POST_PAYMENT",
    PREEBOOK_PREPAID = "Prebook-Prepaid",
    PREBOOK_PREPAID_REDEEM = "Prebook_Prepaid_Redeem",
    PRIME_SLOT = "PrimeSlot",
}

export const CASHBACK_TEXT = "cashback coupon applied successfully";

export const LOADING_TEXT = "Fetching your payment details ...";

export const EVENTS_REFERER = "Events";

export const PAYMENT_OPTION_IDS = {
    FULL_PAYMENT: "full_payment",
    PARTIAL_PAYMENT: "partial_payment",
};

export const PARTIAL_PAYMENT_RADIO_GROUP = {
    NAME: "partial-payment-option",
    TITLE: "Choose payment type",
};

export const STATUS_BAR_COLOR_DEFAULT = "#ffffff";

export const STATUS_BAR_COLOR_DARK = "#000000";

export const UX4_PRIMARY_BLACK = "#686a6d";

export const SCROLL_POSITION = 25;

export const CTA_CONTAINER_DISTANCE_ALERT = "115px";
export const CTA_CONTAINER_WITHOUT_DISTANCE_ALERT = "135px";

export const DEFAULT_BILL_PAYMENT_COMPONENT_PAYLOAD = {
    billToPay: 0,
    totalBillExcludingExtras: 0,
    billAmountToApplyCoupon: 0,
};

export const APPLIED_TEXT = "`{0}` applied";
export const COUPON_SAVING_TEXT = "You saved {0} with this coupon!";

export const SUPER_V3_BENEFITS_KEY = "super_v3_benefits";
export const SUPER_V3_BENEFITS_TYPE = "SUPER_V3_BENEFITS";
export const BENEFITS_TEXT = "BENEFITS";
export const RUPEES_TEXT = "rupees";

export const SCAN_QR = "Scan QR";
export const INACTIVE = "inactive";

// Version thresholds for local cart fetch
export const MIN_ANDROID_VERSION_FOR_LOCAL_CART = 20000; //TODO: update this basis release plan
export const MIN_IOS_VERSION_FOR_LOCAL_CART = 20000; //TODO: update this basis release plan

export const CLEVERTAP_KEYS = {
    DINERS_AF_DEAL_ADD_TO_CART: "ct_deal_add_to_cart",
};

export const CART_TEST_IDS = {
    PROCEED_BUTTON: "proceed-cta-button",
    TABLE_RESERVATION_CART_HEADER: "table-reservation-cart-header",
    HEADER_CONTAINER: "header-container",
    PREVIOUS_PAGE_ELEMENT: "table_booking_header_container",
    ONE_WIDGET_CONTAINER: "one-widget-container",
    PURCHASE_BUTTON: "one-widget-purchase",
    BILL_DETAILS_SECTION: "order-id",
    THINGS_TO_REMEMBER_LIST: "things-to-remember-list",
    ACCORDION_CONTAINER_TNC: "accordion-container-0",
    TABLE_BOOKING_HEADER_CONTAINER: "table_booking_header_container",
    HALF_CARD_OVERLAY: "half-card-overlay",
    ONE_LITE_ADDED: "one-lite-added",
    TABLE_BOOKING_INFO: "table-booking-info",
    PROCEED_CTA_SUBTEXT: "proceed-cta-subtext",
};

export const DO_STORAGE_CART_KEY = "DO_STORAGE_CART_KEY";

export const SUBSCRIPTION_UPSELL_CALLOUT_KEY = "Cart_Page_Pay_Cta";

export const PREVIOUS_CART_ID = "previous-cart-id";

export const SESSION_STORAGE_KEYS = {
    IS_BILL_DETAIL_SECTION_UNCOLLAPSED: "is_bill_detail_section_uncollapsed",
};

export const DEFAULT_REWARDS_WIDGET = {
    rewardsRedeemed: false,
    redeemableRewards: 0,
};

export const COLLAPSIBLE_BILL_DISCOUNT_MESSAGE = "₹{0} saved on the total!";

export const STEAL_STORE_BILL_DETAILS_KEYS = {
    ITEM_TOTAL: "item_total",
    DISCOUNT_DISPLAY_NAME: "discount_display_name",
    DISCOUNT_DESCRIPTION: "discount_description",
    CHARGE_DISPLAY_NAME: "charge_display_name",
    CHARGE_DESCRIPTION: "charge_description",
    CHARGE_FEE: "charge_fee",
    GST_FEE: "gst_fee",
    GRAND_TOTAL: "grand_total",
    BILL_DETAILS_SECTION_END: "bill_details_section_end",
    DISCOUNT_FEE: "discount_fee",
};

export enum STEAL_STORE_BILL_DETAILS_TYPES {
    DISPLAY = "display",
    TOOLTIPDISPLAY = "tooltipdisplay",
    TITLE = "title",
    INFODISPLAY = "infodisplay",
    SEPARATOR = "separator",
    BILL_DETAILS_SECTION_END = "bill_details_section_end",
}

export const BILL_PAYMENT_SHIMMER_DIMENSIONS = {
    HEADER_HEIGHT: 316,
    REWARDS_BLOCK_HEIGHT: 110,
    POOLING_BLOCK_HEIGHT: 65,
    COUPON_BLOCK_HEIGHT: 75,
    BILL_DETAILS_BLOCK_HEIGHT: 160,
};

export const TURBO_SHIMMER_DIMENSIONS = {
    ICON_HEIGHT: 12,
    ICON_WIDTH: 10,
    METHOD_HEIGHT: 12,
    METHOD_WIDTH: 40,
    LINE_HEIGHT: 15,
    LINE_WIDTH: 65,
    PAY_HEIGHT: 52,
    PAY_WIDTH: 100,
    BLOCK_HEIGHT: 40,
};
